module.exports = __webpack_public_path__ + "static/media/flight-black.11a19351.svg";